/* eslint-disable prefer-destructuring */
import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux-auto'
import Api from '#services/api'
import UserInfoHOC from './UserInfoHOC'
import {
  getQualifications as getQualitifactionsFromStorage,
  setQualifications as setQualificationsToStorage,
} from '#services/storage'

export function QualificationsHOC(WrappedComponent) {
  class QualificationsHOCImplementation extends React.Component {
    constructor(props) {
      super(props)
      this.state = {qualifications: []}
    }

    async componentDidMount() {
      this.loadedQualifikationen = getQualitifactionsFromStorage()
      if (!this.loadedQualifikationen) {
        try {
          this.loadedQualifikationen = await Api.getNachweisQualifikationen()
          setQualificationsToStorage(this.loadedQualifikationen)
        } catch (error) {
          actions.error.writeError({error})
        }
      }
      this.setQualifications()
    }

    componentDidUpdate(prevProps) {
      if (prevProps.userInfo.qualifikationenBerufKey !== this.props.userInfo.qualifikationenBerufKey) {
        this.setQualifications()
      }
    }

    setQualifications() {
      let qualifications = []
      if (this.loadedQualifikationen) {
        const {qualifikationenBerufKey} = this.props.userInfo
        if (qualifikationenBerufKey && this.loadedQualifikationen[qualifikationenBerufKey]) {
          qualifications = this.loadedQualifikationen[qualifikationenBerufKey].qualifications
        }
      }
      this.setState({
        qualifications,
      })
    }

    render() {
      return <WrappedComponent {...this.props} qualifications={this.state.qualifications} />
    }
  }

  QualificationsHOCImplementation.propTypes = {
    userInfo: PropTypes.object.isRequired,
  }
  return QualificationsHOCImplementation
}

export default function (props) {
  return UserInfoHOC(QualificationsHOC(props))
}
